module.exports = __webpack_public_path__ + "static/media/writeOff.6f236937.svg";